import { useState, useCallback } from 'react'
import axios from 'utils/axios/modules/auth'
import { setStorage, getStorage, removeStorage } from 'utils/localstorage'
import Cookies from 'js-cookie'

const kIsAuthenticated = 'isAuthenticated'
const kAuthToken = 'access_token'
const kFirstname = 'firstname'
const kLastname = 'lastname'
const kDevIsAlreadySwitchedToNewNinal = 'dev_is_already_switched_to_new_ninal'
const kSsoSessionKey = 'common_sso_session_key'
const kIsAgreement = 'isAgreement'

function resetStorageFunc() {
  // storageの設定前にAPIリクエストが行われるとAPIキーが前のものになるのでPromiseで返す

  return new Promise((resolve, reject) => {
    try {
      removeStorage(kIsAuthenticated)
      removeStorage(kAuthToken)
      removeStorage(kFirstname)
      removeStorage(kLastname)
      removeStorage(kDevIsAlreadySwitchedToNewNinal)
      removeStorage(kIsAgreement)
      // 認証基盤 共通cookie
      Cookies.remove(kSsoSessionKey, {
        ...(process.env.REACT_APP_ENV === 'local' ? {} : { domain: process.env.REACT_APP_SSO_COOKIE }),
      })

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

function setStorageFunc(data) {
  // 一定時間保持したいのでlocalstorageに保存する
  // storageの設定前にAPIリクエストが行われるとAPIキーが前のものになるのでPromiseで返す

  return new Promise((resolve, reject) => {
    try {
      setStorage(kIsAuthenticated, true)
      setStorage(kAuthToken, data[kAuthToken])
      setStorage(kFirstname, data[kFirstname])
      setStorage(kLastname, data[kLastname])
      setStorage(kDevIsAlreadySwitchedToNewNinal, data[kDevIsAlreadySwitchedToNewNinal])
      setStorage(kIsAgreement, !!data['agreement'])

      // 認証基盤 共通cookie
      Cookies.set(kSsoSessionKey, data['encrypted_contact_id'], {
        expires: 1,
        ...(process.env.REACT_APP_ENV === 'local' ? {} : { domain: process.env.REACT_APP_SSO_COOKIE }),
      })

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

async function logIn(data, setIsLoginRequesting, setLoginErrors, setIsLoginSuccess) {
  setIsLoginRequesting(true)
  await resetStorageFunc()

  const { code } = data

  return await axios
    .myPageLogin(code)
    .then(async (response) => {
      await setStorageFunc(response.data)
      setIsLoginSuccess(true)
    })
    .catch((errorMessages) => {
      setLoginErrors(errorMessages)
    })
    .finally(() => {
      setIsLoginRequesting(false)
    })
}

function isLoggedIn() {
  const flag = getStorage(kIsAuthenticated)

  return flag !== undefined && flag === 'true'
}

function isAlreadySwitchedToNewNinal() {
  const flag = getStorage(kDevIsAlreadySwitchedToNewNinal)

  return flag !== undefined && flag === 'true'
}
function isAgreementMyTanakaTermsOfService() {
  const flag = getStorage(kIsAgreement)

  return flag !== undefined && flag === 'true'
}

async function logout(setLogoutErrors, setIsLogoutSuccess) {
  return await axios
    .myPageLogout()
    .then(async () => {
      setIsLogoutSuccess(true)
      await resetStorageFunc()

      window.location.href =
        process.env.REACT_APP_SSO_LOGOUT_URL +
        encodeURIComponent(window.location.protocol + '//' + window.location.host + '/ninal/mypage/login')
    })
    .catch((errorMessages) => {
      setLogoutErrors(errorMessages)
    })
}

function useLoginCallbackHook() {
  // login関係
  const [isLoginRequesting, setIsLoginRequesting] = useState(false)
  const [isLoginSuccess, setIsLoginSuccess] = useState(false)
  const [loginErrors, setLoginErrors] = useState([])
  const execLogIn = useCallback(async (data) => {
    return await logIn(data, setIsLoginRequesting, setLoginErrors, setIsLoginSuccess)
  }, [])

  // logout関係
  const [isLogoutSuccess, setIsLogoutSuccess] = useState(false)
  const [logoutErrors, setLogoutErrors] = useState([])
  const execLogOut = useCallback(async () => {
    return await logout(setLogoutErrors, setIsLogoutSuccess)
  }, [])

  // その他
  const isAuthenticated = isLoggedIn()
  const isSwitched = isAlreadySwitchedToNewNinal()
  const isAgreement = isAgreementMyTanakaTermsOfService()

  const webShopMypageURL = `${process.env.REACT_APP_SHOP_URL}/Form/User/MyPage.aspx`

  return {
    // login関係
    isLoginRequesting,
    loginErrors,
    setLoginErrors,
    isLoginSuccess,
    execLogIn,

    // logout関係
    isLogoutSuccess,
    logoutErrors,
    setLogoutErrors,
    execLogOut,

    // その他
    isAuthenticated,
    isSwitched,
    isAgreement,

    // ストレージ関係
    resetStorageFunc,
    setStorageFunc,

    //webshop
    webShopMypageURL,
  }
}

export default useLoginCallbackHook
